const translations = {
    en: {
        welcome: {
            customize_your_stay_card: {
                button: "DISCOVER"
            }
        }
    },
    de: {
        welcome: {
            customize_your_stay_card: {
                button: "ENTDECKEN"
            }
        }
    },
    es: {
        welcome: {
            customize_your_stay_card: {
                button: "DESCUBRA MAS"
            }
        }
    },
    fr: {
        welcome: {
            customize_your_stay_card: {
                button: "DÉCOUVREZ"
            }
        }
    },
    it: {
        welcome: {
            customize_your_stay_card: {
                button: "SCOPRI DI PIU'"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/welcome/CustomizeYourStayCard.js